import {useMemo} from "react";
import {
    convertPaymentMethodToPaymentType,
    paymentMethodFormDefaultValues
} from "../components/Forms/Billing/PaymentMethodForm/PaymentMethodForm.utils";
import {PaymentMethodType} from "../store/types/Billing";
import {useSelector} from "react-redux";
import {ReduxState} from "../store/types";
import {OwnerPaymentMethod, PaymentMethodInfo} from "../store/types/Payment";
import {CustomerInfoDetails, GlobalCurrencyInfo} from "../store/types/CustomerInfo";
import {Subdivision} from "../store/types/Subdivision";
import {BillingStateType} from "../store/reducers/billing/reducer";

export const useMakePaymentData = () => {


    const {isMakeTransactionLoading} = useSelector<
        ReduxState,
        BillingStateType
    >((state) => state.billing);


    const currency = useSelector<ReduxState, GlobalCurrencyInfo | undefined>(
        (state) => state.generic.globalCurrency,
    );

    const subdivisionsList = useSelector<ReduxState, Subdivision[]>(
        (state) => state.generic.subdivisionsList,
    );

    const paymentMethod = useSelector<
        ReduxState,
        PaymentMethodInfo | undefined
    >((state) => state.billing.customerPaymentMethod);


    const customerInfo = useSelector<
        ReduxState,
        CustomerInfoDetails | undefined
    >((state) => state.billing.customerInfo);


    const ownerPaymentsMethods = useSelector<
        ReduxState,
        OwnerPaymentMethod[] | undefined
    >((state) => state.billing.ownerPaymentsMethods);


    const paymentsMethods = useMemo(() => {
        const _paymentMethods: PaymentMethodType[] = [];
        if (!ownerPaymentsMethods) return _paymentMethods;

        for (const pm of ownerPaymentsMethods) {
            const _type = convertPaymentMethodToPaymentType(pm.payment_method);
            if (_paymentMethods.findIndex(e => e === _type) === -1) {
                _paymentMethods.push(_type);
            }
        }

        _paymentMethods.sort((a, b) => (a as number) - (b as number));

        return _paymentMethods;
    }, [ownerPaymentsMethods]);


    const currentMethod = useMemo(
        () =>
            ownerPaymentsMethods?.find(
                (v) => v.i_payment_method === paymentMethod?.i_payment_method,
            ),
        [ownerPaymentsMethods],
    );


    const initialValues = useMemo(() => {
        return {
            ...paymentMethodFormDefaultValues,
            paymentType: paymentsMethods?.includes(PaymentMethodType.CreditCard)
                ? PaymentMethodType.CreditCard
                : paymentsMethods.length > 0
                    ? paymentsMethods[0]
                    : PaymentMethodType.BankAccount,
            address: customerInfo?.baddr1 || '',
            state:
                subdivisionsList.find((v) => v.name === customerInfo?.state)
                    ?.i_country_subdivision || null,
            country: customerInfo?.country || '',
            city: customerInfo?.city || '',
            postalCode: customerInfo?.zip || '',
            billingPhone: customerInfo?.phone1 || '',
            amount: currentMethod?.min_allowed_payment?.toString() || '0',
            isDefaultPaymentMethod: !!currentMethod,
            setAsDefaultPaymentMethod: false,
        };
    }, [paymentsMethods, customerInfo]);


    return {
        initFormData: initialValues,
        data: {
            paymentMethod,
            customerInfo,
            ownerPaymentsMethods,
            isMakeTransactionLoading,
            currency,
            paymentsMethods
        }

    };
};